import 'core-js/stable/string/includes';

// https://github.com/zloirock/core-js/issues/618#issuecomment-522618151
// https://github.com/zloirock/core-js/issues/619#issuecomment-522624271
import 'core-js/stable/symbol/iterator';

import 'core-js/stable/array/from';
import 'core-js/stable/object/entries';
import 'core-js/stable/dom-collections/for-each';

import Swiper from 'swiper';
import Slider from './components/slider';
import UploadPhoto from './components/upload_photo';

import CookiesNotice from './components/cookies_notice';
import NewPasswordLink from './components/new_password_link';

import GeoPointInput from './components/geo_point_input';
import GeoPoint from './components/geo_point';
import Directions from './components/directions';
import * as Map from './components/map/element';

import * as Analytics from './components/analytics/element';

import InputWithCurrentLocationButton from
	'./components/input_with_current_location_button';

import InputWithClearButton from './components/input_with_clear_button';

import TransportTypePrices from './components/transport_type_prices';

import CurrencySwitcher from './components/currency_switcher';
import TransportationRequests
	from './components/cabinet/transportation_requests';

import PriceInput from './components/price_input';
import PriceSuggestion from './components/price_suggestion';
import 'whatwg-fetch';
import TransportationRequestForm from './components/transportation_requests';
import CarrierTutorial from './components/carrier_tutorial';
import SpecialSelect from './components/special_select';
import EntryField from './components/entry_field';
import EntryFieldCheckbox from './components/entry_field_checkbox';
import FormMenu from './components/form_menu';
import GoogleSignInButton from './components/google_sign_in_button';

import intlTelInput from 'intl-tel-input';
import { SimpleModal } from './components/simple_modal';
import FormObject from './components/form_object';
import Quality from './components/quality';
import ManagerRegions from './components/cabinet/manager_regions';
import MultiFields from './components/multi_fields';
import RequiredCheckboxes from './components/required_checkboxes';
import Permissions from './components/permissions';
import Header from './components/header';
import MoreServices from './components/more_services';

export class App {
	document_ready() {
		// Ads Analytics
		document.querySelectorAll('[data-analytics]').forEach(
			element => new Analytics.Element(element)
		);

		// Telephone inputs
		document.querySelectorAll('input[data-name*="phone_number"]').forEach(
			element => {
				const config = {
					utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
					hiddenInput: element.dataset.name,
					nationalMode: false,
					preferredCountries: [window.locale.split('-')[1].toLowerCase()],
					localizedCountries: JSON.parse(element.dataset.countryTranslations),
					autoPlaceholder: 'off'
				}

				const dataOnlyCountries = element.dataset.onlyCountries
				if (dataOnlyCountries) {
					config.onlyCountries = JSON.parse(dataOnlyCountries)
				}

				const initialCountry = element.dataset.initialCountry
				if (initialCountry) {
					config.initialCountry = initialCountry
				}

				element.telInput = intlTelInput(element, config);

				// Не получается через setCountry установить сразу dialCode в element.value 
				if (initialCountry) {
					const dialCode = element.telInput.selectedCountryData.dialCode

					if (dialCode) {
						const formattedDialCode = `+${dialCode}`
						const reg = new RegExp(`^\\${formattedDialCode}`)
						const existsPrefix = !!element.value.match(reg)
						if (!existsPrefix) {
							element.value = `${formattedDialCode}${element.value}`
						}
					}
				}

				if (element.classList.contains('disabled')) {
					element.telInput.flagsContainer.classList.add('disabled');
				}
			}
		);

		// Inputs with clear buttons
		document.querySelectorAll('input.with_clear_button').forEach(
			input => new InputWithClearButton(input)
		);

		document.querySelectorAll('.new_password_link').forEach(
			element => new NewPasswordLink(element)
		);

		new Header(document.body.querySelector('header'));

		
		// Wrap forms with FormObject
		document
			.querySelectorAll('form:not(.export)')
			.forEach(form => new FormObject(form));

		// Submit filtering form on any filtering input change
		const filtering_form = document.querySelector('form#filtering');
		if (filtering_form) {
			const inputs_for_exclude = Array.from(
				filtering_form.querySelectorAll(
					'.date_range input:not(.entry_field__radio),' +
					'input.special_select__toggle'
				)
			);
			Array.from(filtering_form.querySelectorAll('input, select'))
				.filter(element =>!inputs_for_exclude.includes(element))
				.forEach(
					element => {
						function submitForm() {
							if (element.form.geo_point_inputs) {
								setTimeout(
									() => element.form.dispatchEvent(new Event('submit')),
									200
								);
							} else {
								element.form.submit();
							}
						}

						element.addEventListener('change', submitForm);
					}
				);
		}

		// Submit pagination form on any pagination input change
		const pagination_block = document.querySelector('div.pagination');
		if (pagination_block) {
			pagination_block.querySelectorAll('input, select').forEach(
				element =>
					element.addEventListener('change', () => element.form.submit())
			);
		}

		// Prevent `.` typing in number inputs with step = 1
		document.querySelectorAll('input[type="number"][step="1"]').forEach(
			input => input.addEventListener('keypress', event => {
				if (event.key == '.') {
					event.preventDefault();
					return false;
				}
			})
		);

		// Enable Cccombo
		if (typeof Cccombo !== 'undefined') {
			Cccombo.container =
				element => element.closest('.container') || document.body;

			document.querySelectorAll('.cccombo').forEach(element => {
				element.cccombo = new Cccombo(element);
				element.cccombo.init();
			});
		}

		// Display something only when checkbox checked

		document.querySelectorAll('.display_by_state').forEach(container => {
			const label = container.querySelector(':scope > label'),
				checkbox = label.querySelector(':scope > input[type="checkbox"]'),
				input_container = label.nextElementSibling;

			function show_input_container() {
				input_container.classList.remove('hidden');
			}

			checkbox.addEventListener('change', () => {
				if (checkbox.checked) {
					input_container.querySelectorAll('input, select').forEach(element => {
						element.value = element.value || element.old_value || '';
						element.old_value = null;
					});
					show_input_container();
				} else {
					input_container.classList.add('hidden');
					input_container.querySelectorAll('input, select').forEach(element => {
						element.old_value = element.value;
						element.value = null;
						element.dispatchEvent(
							new Event(element.tagName == 'input' ? 'input' : 'change')
						);
					});
				}
			});

			if (checkbox.checked) show_input_container();
		});

		// `input[type="number"]` should allow only numbers
		// https://stackoverflow.com/a/469362/2630849
		const number_input_filter = value => /^-?\d*[.,]?\d*$/.test(value);
		document.querySelectorAll('input[type="number"]').forEach(number_input => {
			[
				'input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select',
				'contextmenu', 'drop'
			].forEach(event_type => {
				number_input.addEventListener(event_type, () => {
					if (number_input_filter(number_input.value)) {
						number_input.oldValue = number_input.value;
						number_input.oldSelectionStart = number_input.selectionStart;
						number_input.oldSelectionEnd = number_input.selectionEnd;
					} else if (
						Object.prototype.hasOwnProperty.call(number_input, 'oldValue')
					) {
						number_input.value = number_input.oldValue;
						number_input.setSelectionRange(
							number_input.oldSelectionStart, number_input.oldSelectionEnd
						);
					}
				});
			});
		});

		// `button` is not focused while clicked in macOS and iOS
		// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
		document.querySelectorAll('button[type="submit"][name]').forEach(button => {
			const form = button.form;
			const input = form.querySelector(
				`input[name="${button.name}"][value="${button.value}"]`
			);
			if (input) return;

			button.addEventListener('click', () => {
				const input = document.createElement('input');
				const existed_input = form.querySelector(
					`input[name="${button.name}"]`
				);
				if (existed_input) existed_input.remove();
				input.type = 'hidden';
				input.name = button.name;
				input.value = button.value;
				form.appendChild(input);
			});
		});

		const currency_switcher = new CurrencySwitcher(
			document.querySelector('body > header .currency_switcher')
		);


		// Start form manager create offer for carrier
		const offerSection = document.querySelector('[id*="offer_by_manager"]');
		if (offerSection) {
			new TransportationRequests.OfferByManager(
				offerSection, currency_switcher
			);
		}

		// Start form assign transportation_request to manager
		const assignToInput = document.querySelector('.assign_to_autocomplete');
		if (assignToInput) {
			new TransportationRequests.AssignToAutocomplete(assignToInput);
		}

		const firstStepForm =
			document.querySelector('#transportation_request_first_step_form');
		if (firstStepForm) {
			const transportTypes = firstStepForm.querySelector('.truck');

			if (transportTypes) {
				firstStepForm.addEventListener('distance_updated', event => {
					if (event.detail === null) return;

					transportTypes
						.control
						.dispatchEvent(new CustomEvent('update_state'));
				});
			}
		}


		// Transport Type Prices
		// Turned off
		// https://3.basecamp.com/3101957/buckets/4544867/todos/2469648653#__recording_2942204810
		document.querySelectorAll('[data-transport-type-prices]').forEach(
			container => new TransportTypePrices(container, currency_switcher)
		);

		const shipment_parameters =
			document.querySelector('#shipment_parameters legend');

		if (shipment_parameters) {
			shipment_parameters.addEventListener('click', event => {
				event.target.classList.toggle('opened');
			});
		}

		document.querySelectorAll('[data-tooltip-content]').forEach(
			el => $(el).tooltip({content: el.dataset.tooltipContent})
		);

		document.querySelectorAll('input[type="radio"][id^="question_"]').forEach(
			radio => {
				radio.parentNode.querySelector(`label[for="${radio.id}"]`)
					.addEventListener('click', function(event) {
						event.preventDefault();
						radio.checked = !radio.checked;
					});
			}
		);

		document.querySelectorAll('.history_of_changes > .update_status').forEach(
			formElement => {
				new TransportationRequests.UpdateStatusWithComment(formElement);
			}
		);

		document.querySelectorAll('.simple_modal').forEach(
			element => new SimpleModal(element)
		);

		const payment_update_status_forms =
			document.querySelectorAll('section.payments table form.update_status');
		if (payment_update_status_forms.length > 0) {
			payment_update_status_forms.forEach(
				formElement =>
					formElement.querySelectorAll('input, select').forEach(
						element =>
							element.addEventListener('change', () => element.form.submit())
					)
			);
		}

		document.querySelectorAll('section.payments table form.update_status')
			.forEach(
				formElement => {
					formElement.querySelectorAll('li').forEach(
						liElement => {
							if (
								liElement
									.querySelector('span')
									.classList
									.contains('do_not_change_status')
							) return;

							liElement.addEventListener('click', () => {
								if (confirm(liElement.dataset.confirm)) {
									formElement.submit();
								}
							});
						}
					);
				}
			);

		// Price input previews
		document.querySelectorAll('.price_input').forEach(
			element => new PriceInput(element)
		);

		const moreServices = document.getElementById('more_services');
		if (moreServices) {
			new MoreServices(moreServices);
		};

		document.querySelectorAll('.transportation_request > .offers > .payment')
			.forEach(
				container => new TransportationRequests.Offers.Payment(container)
			);

		// Cookies notice
		new CookiesNotice(document.querySelector('.cookies_notice'));

		// Price suggestion in transportation offer creation page
		document.querySelectorAll('.price_suggestion')
			.forEach(container => new PriceSuggestion(container, currency_switcher));

		// Open API version using select element
		const api_versions_selector =
			document.querySelector('#api_versions select');
		if (api_versions_selector) {
			api_versions_selector.addEventListener('change', event => {
				document.location.pathname = event.target.value;
			});
		}

		// Chat between Shipper and Carrier
		document.querySelectorAll('button.toggle_chat').forEach(
			button => new TransportationRequests.Offers.Chat(button)
		);

		// Movizor block
		document.querySelectorAll('button.toggle_movizor_info').forEach(
			button => new TransportationRequests.Offers.Movizor(button)
		);

		// Rate after Transportation
		document.querySelectorAll('article.offer > section.rating form').forEach(
			form => new TransportationRequests.Offers.Rating(form)
		);

		// Offer Forms for Transportation Requests
		document.querySelectorAll('form.offer').forEach(
			form => new TransportationRequests.Offers.Form(form)
		);

		// Transport photo slider
		document.querySelectorAll('.transport_photos_slider').forEach(
			slider => new Slider(slider)
		);

		// Transport slider
		document.querySelectorAll('.swiper').forEach(
			slider => {
				console.log(slider.dataset.slidesPerView)
				slider.swiper = new Swiper(slider, {
					// https://github.com/nolimits4web/swiper/issues/2621#issuecomment-586414784
					navigation: {
						nextEl: slider.querySelector('.swiper-button-next'),
						prevEl: slider.querySelector('.swiper-button-prev')
					},
					slidesPerView: slider.dataset.slidesPerView,
					breakpoints: {
						1200: {
							slidesPerView: slider.dataset.slidesPerView
						}
					}
				});
			}
		);

		// Special select
		document.querySelectorAll('.special_select').forEach(
			select => new SpecialSelect(select)
		);

		// Entry field
		document.querySelectorAll('.entry_field').forEach(
			field => new EntryField(field)
		);

		// Entry field checkbox
		document.querySelectorAll(
			'.entry_field__checkbox[type="checkbox"]'
		).forEach(field => new EntryFieldCheckbox(field));

		// Permissions
		const permissions = document.querySelector('.permissions');
		if (permissions) {
			new Permissions(permissions);
		}

		// Required checkboxes
		document.querySelectorAll(
			'.transport_types_select, .permissions,' +
				' .removal.form_menu, .on_pallets.form_menu'
		).forEach(checkbox => new RequiredCheckboxes(checkbox));

		// Form menu
		Array
			.from(document.querySelectorAll('.form_menu'))
			.map(field => new FormMenu(field))
			.forEach(form_menu => form_menu.init());

		// Photos

		document.querySelectorAll('.photos').forEach(
			photos_section => new UploadPhoto(photos_section)
		);

		document.querySelectorAll('.multi_fields').forEach(item => {
			new MultiFields(item);
		});

		// Region manager select
		const manager_regions = document.querySelector('#manager_regions');
		if (manager_regions) new ManagerRegions(manager_regions);

		// Promo code check
		document.querySelectorAll('.entry_field__element--promocode')
			.forEach(input => {
				const
					validClass = 'entry_field__element--promocode-valid',
					invalidClass = 'entry_field__element--invalid',
					checkPromoCode = event => {
						if (!input.checkValidity()) return;

						const params = new URLSearchParams;
						params.set('promo_code[name]', input.value);
						params.set('locale', window.locale);

						fetch(
							`/api/v2/promo_codes/discount?${params.toString()}`,
							{ method: 'GET', credentials: 'same-origin' }
						)
							.then(response => {
								return response
									.json()
									.then(json => response.ok ? json : Promise.reject(json));
							})
							.then(json => {
								input.classList.add(validClass);
								input
									.entry_field
									.discount
									.querySelector('.entry_field__discount__percent')
									.textContent = json.data;
							})
							.catch(error => {
								console.log(error);
								event.target.removeEventListener('click', checkPromoCode);
								input.classList.add(invalidClass);
								input.entry_field.error.textContent = error.data;
							});
					};

				input.addEventListener('input', event => {
					input.classList.remove(validClass, invalidClass);
					input.entry_field.error.textContent = '';
					if (input.checkValidity()) {
						input
							.entry_field
							.apply_button
							.addEventListener('click', checkPromoCode);
					}
				});
			});

		// Copy to clipboard button

		document.querySelectorAll('button.copy').forEach(
			button => button.addEventListener('click', () => {
				button.copyTimeout = null;
				if (button.copyTimeout) return;

				let callback = () => {
					button.copyTimeout = setTimeout(() => {
						button.copyTimeout = null;
					}, 2000);
				};

				navigator.clipboard.writeText(button.value).then(callback);
			})
		);

		// Quality form

		document.querySelectorAll('form.update_quality').forEach(item => {
			new Quality(item);
		});

		// Shipment parameters inputs

		document
			.querySelector('#shipment_parameters[data-required="true"]')
			?.elements
			?.forEach(element => element.setAttribute('required', 'true'));

		if (typeof $ === 'undefined') return;

		TransportationRequestForm.init();
		// CarrierTutorial.init();
	}

	google_init() {
		// Google Map containers
		document.querySelectorAll('.google_map').forEach(
			container => new Map.Element(container)
		);

		// Inputs with Google Autocomplete and optional binding to Google Map
		document.querySelectorAll('[autocomplete*="street-address"]').forEach(
			input => {
				input.form.form_object.add_geo_point(new GeoPointInput(input));
			}
		);

		// Regular element (not input) with binding to Google Map
		document.querySelectorAll('.geo_point').forEach(
			input => new GeoPoint(input)
		);

		// Directions for Geo Points
		document.querySelectorAll('[data-directions]').forEach(
			element => new Directions(element)
		);

		// Inputs with current location buttons
		document.querySelectorAll('.current_location').forEach(
			container => new InputWithCurrentLocationButton(container)
		);

		// Google sign in button
		const google_sign_in_button =
			document.getElementById('google_sign_in_button');
		if (google_sign_in_button) new GoogleSignInButton(google_sign_in_button);
	}
}
